
import React, { useEffect, useRef } from "react";
import { useState } from "react";
import styled from "styled-components";
import call from '../../assets/perks/call.svg';
import discord from '../../assets/perks/discord.svg';
import instagram from '../../assets/perks/instagram.svg';
import message from '../../assets/perks/message.svg';
import overlay from '../../assets/perks/overlay.svg';
import Modal from 'react-modal';
import PerkTutorial from './PerkTutorail';

const CardWrapper = styled.div`
    border-radius: 14px;
    margin: 8px;
    border: 2px solid transparent;
    /* height: 127px; */
    @media only screen and (max-device-width: 480px) {
        margin: 0px;
    }
`;


const CardInner = styled.div`
    width: 171px;
    /* height: 173px; */
    padding: 16px 13px;
    border-radius: 14px;
    color: white;
    border: 4px solid #000000;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;

`;

const Subtitle = styled.div`
    font-family: IBM Plex Mono;
    font-style: normal;
    font-weight: 600;
    font-size: 15.5866px;
    line-height: 120%;
    /* or 19px */
    letter-spacing: -0.03em;
    color: #FFFFFF;
`;


const Image = ({id}) => {
    if(id == 1) return (<img style={{width: 70}} src={message} />);
    if(id == 5) return (<img style={{width: 70}} src={call} />);
    if(id == 4) return (<img style={{width: 70}} src={discord} />);
    // if(id == 3) return (<img style={{width: 70}} src={discord} />);
    if(id == 6) return (<img style={{width: 70}} src={instagram} />);
    if(id == 7) return (<img style={{width: 70}} src={overlay} />);
    return (<></>)
}

/* 
    4 props
    1. preksData: data of all perks
    2. setActive a function to toggle the highlighed perk with non highlighted one, makes the perk clickable
    3. active current active index perk
    4. isStatic if the perks are static for view only, 2nd and 3rd props dont change the perks list at all if this is true
    UPDATE: using isStatic to now open a modal to explain how the perk works.
*/
export default function PerksList({perksData, setActive, active, isStatic}) {
    const [perks, setPerks] = useState(perksData);
    const [showModal, setShowModal] = useState(false);
    const [modal, setModal] = useState();

    const closeModal = () => {
        setShowModal(false);
    };

    useEffect(() => {
        if(perksData.length > 0) setPerks(perksData);
    }, [perksData]);

    const Card = ({item, index}) => {
        return (
            <CardWrapper 
                onClick={() => {
                    if(!isStatic)
                        setActive(index + 1)
                    else {
                        setModal(item.id)
                        // setShowModal(true);                    
                    }
                }}
                style={{
                    borderColor: isStatic ? 'transparent' : (index + 1 != active) ? 'transparent' : 'white'
                }}>
                {/* <CardInner className={`perk-tile perk-${item.id}`}> */}
                <CardInner className={`perk-tile perk-1`}>
                    <Subtitle>{item.name}</Subtitle>
                    <Image id={item.id} />
                </CardInner>                
            </CardWrapper>
        );
    }

    const perkCards = perks.map((item, index) => <Card key={`card-${index}`} index={index} item={item} />);

    return (
        <>
            {perkCards}

            <Modal
                isOpen={showModal}
                onRequestClose={closeModal}
                style={{
                content: {
                    background: "#0F0F0F",
                    maxWidth: 450,
                    maxHeight: 478,
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginTop: "auto",
                    marginBottom: "auto",
                    border:"none",
                    padding: 0,
                }
                }}
            >
                    <PerkTutorial perkId={modal} />
            </Modal>
        </>
    )
}
